<template>
  <gj-table
      :index="false"
      :loading="loading"
      border
      :data="tableData"
      :columns="columns"
      :show-overflow="false"
      :min-height="400"
      :offset-height="65">
    <template v-slot:sku="{row}">
      <div>
        <gj-text>{{row.productName | defaultShow}}</gj-text>
      </div>
      <div>{{row.sku | defaultShow}}</div>
      <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
    </template>
    <template v-slot:msku="{row}">
      <div>{{row.msku | defaultShow}}</div>
      <div>{{row.fnsku | defaultShow}}</div>
      <div>{{row.asin | defaultShow}}</div>
    </template>
    <template v-slot:creator="{row}">
      <div>{{row.createUserName | defaultShow}}</div>
      <div>{{row.createTime | defaultShow}}</div>
    </template>
    <template #footer>
      <div v-gutter="20" class="default">
        <span>产品种类数：{{tableData.length}}</span>
        <span>交货量合计：{{tableData | sum('deliveryQuantity')}}</span>
        <span>总金额合计：{{tableData | sum('amount') | amount | defaultShow(currencySymbol)}}</span>
      </div>
    </template>
  </gj-table>
</template>

<script>
  import {getPurchaseOrderDelivery} from "../../../../../../../../api/purchase";
  import {ProductEnum} from "../../../../../../../../utils/options";

  export default {
    name: "app-op-purchase-order-delivery",
    props: {
      purchaseOrder: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        loading: false,
        columns: [
          {id: 'deliveryNoteCode', header: '交货单号', field: 'deliveryNoteCode', width: '140px', fixed: 'left'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px', fixed: 'left'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px', fixed: 'left'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '200px'},
          {id: 'deliveryQuantity', header: '交货量', field: 'deliveryQuantity', width: '80px', align: 'right'},
          {id: 'includeTaxPrice', header: '含税单价', prefix: 'currencySymbol', field: 'includeTaxPrice', width: '100px', align: 'right'},
          {id: 'amount', header: '金额', field: 'amount', prefix: 'currencySymbol', width: '100px', align: 'right'},
          {id: 'expectDeliveryDate', header: '预计交货日期', field: 'expectDeliveryDate', width: '120px'},
          {id: 'actualDeliveryDate', header: '实际交货日期', field: 'actualDeliveryDate', width: '120px'},
          {id: 'creator', header: '创建人/创建时间', field: 'slot:creator', width: '160px'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '250px'},
        ],
        productTypeOption: ProductEnum.typeOption
      }
    },
    created() {
      this.loading = true;
      getPurchaseOrderDelivery(this.purchaseOrder.id)
        .then(data => {
          this.tableData = data;
        })
        .complete(() => this.loading = false);
    },
    computed: {
      currencySymbol() {
        if (this._.isEmpty(this.tableData)) {
          return '';
        }
        return this.tableData[0].currencySymbol;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
